import { render, staticRenderFns } from "./GeneralCursosXgrupo.vue?vue&type=template&id=76aa0489&scoped=true"
import script from "./GeneralCursosXgrupo.vue?vue&type=script&lang=js"
export * from "./GeneralCursosXgrupo.vue?vue&type=script&lang=js"
import style0 from "./GeneralCursosXgrupo.vue?vue&type=style&index=0&id=76aa0489&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76aa0489",
  null
  
)

export default component.exports